import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface IItemAssigmentResponse {
  _id: string;
  userId: string;
  userName: string;
  platform: string;
  version: string;
  assignmentContentType: number;
  assignmentType: number;
  assignId: string;
  assignName: string;
  mobileAnswer: any[];
  s3Answer: any[];
  mobileQrcode: string;
  action: string;
  createAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface SignInState {
  loading: boolean;
  data: IItemAssigmentResponse[];
  totalPage: number;
  error: string;
  fetched: boolean;
}

const initialState: SignInState = {
  loading: false,
  data: [],
  error: null,
  totalPage: 1,
  fetched: false,
};

export const assigmentSlice = createSlice({
  name: "assigment",
  initialState,
  reducers: {
    getAssigmentAnswer: (state, action) => {
      state.loading = true;
      state.fetched = false;
    },
    getAssigmentAnswerSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data.assigments;
      state.error = "";
      state.fetched = true;
      state.totalPage = action.payload.data.totalPage;
    },
    getAssigmentAnswerFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.data = [];
      state.error = "error";
      state.fetched = true;
      state.totalPage = 1;
    },
  },
});

export const {
  getAssigmentAnswer,
  getAssigmentAnswerSuccess,
  getAssigmentAnswerFailure,
} = assigmentSlice.actions;

export default assigmentSlice.reducer;
